(function() {
  var src = '';
  try { src = document.currentScript.src; } catch(e) {}
  var base = src.substring(0, src.lastIndexOf('/') + 1);
  if (!base) {
    var ss = document.querySelectorAll('script[src]');
    for (var i = ss.length - 1; i >= 0; i--) {
      if (ss[i].src.indexOf('global.js') !== -1) { base = ss[i].src.substring(0, ss[i].src.lastIndexOf('/') + 1); break; }
    }
  }
  function loadSync(url) {
    try {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url, false);
      xhr.send(null);
      if (xhr.status === 200 && xhr.responseText.length > 100) {
        var s = document.createElement('script');
        s.textContent = xhr.responseText;
        document.head.appendChild(s);
        return true;
      }
    } catch(e) { console.warn('global.js loader:', url, e); }
    return false;
  }
  if (base) {
    loadSync(base + 'global-p1.js');
    loadSync(base + 'global-p2.js');
    loadSync(base + 'global-p3.js');
  }
})();